"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tokens_1 = require("../tokens");
exports.StringBuildInFunctions = {
    string: {
        function: (obj) => {
            return {
                name: tokens_1.LiteralTokens.StringLiteral,
                image: String(obj[0].image),
            };
        },
        arguments: ['obj'],
    },
};
